// extracted by mini-css-extract-plugin
export var deliveryRow = "_r3-a";
export var fixedHeight = "_r3-4";
export var freightLogo = "_r3-9";
export var fullWidth = "_r3-3";
export var priceColumn = "_r3-5";
export var radioSelected = "_r3-7";
export var radioUnselected = "_r3-6";
export var selectedOption = "_r3-2";
export var selectedOptionContainer = "_r3-1";
export var selection = "_r3-0";
export var tallSkeletonText = "_r3-8";